import "@splidejs/splide/dist/css/splide-core.min.css";
import { Splide } from "@splidejs/splide";
import { AutoScroll } from "@splidejs/splide-extension-auto-scroll";

/**
 * サムネイル付きスライダー
 * design詳細ページ
 */
document.addEventListener("DOMContentLoaded", function () {
    const main = document.querySelector("#js-design-main");
    const thumbs = document.querySelectorAll("#js-design-thumbs .p-single-design__gallery-thumb-item");
  
    if (!main || thumbs.length === 0) return;
  
    // メインスライダー
    const mainSlider = new Splide(main, {
      type: "slide",
      rewind: true,
      pagination: false,
      arrows: false,
      speed: 900,
    });
  
    mainSlider.mount();
  
    // サムネイルクリックでメイン切替
    thumbs.forEach((thumb, index) => {
      thumb.addEventListener("click", function () {
        mainSlider.go(index);
  
        // is-active を付け替える
        thumbs.forEach(t => t.classList.remove("is-active"));
        thumb.classList.add("is-active");
      });
    });
  
    // 初期状態
    thumbs[0].classList.add("is-active");
  });